<template>
    <div class="company-detail-carousel">
        <div :class="{'justify-content-between': title.length > 0, 'justify-content-end': title.length == 0}" class="d-flex align-items-center">
            <h3 v-if="title" class="other-summer-camps__courses__title mb-0" v-text="title"></h3>

            <div class="company-detail-carousel__directions">
                <a class="company-detail-carousel__directions__btn company-detail-carousel__directions__btn--prev"
                   href="javascript:void(0)"
                   @click="prev">
                    <i class="fa fa-angle-left"></i>
                </a>
                <a class="company-detail-carousel__directions__btn company-detail-carousel__directions__btn--next"
                   href="javascript:void(0)"
                   @click="next">
                    <i class="fa fa-angle-right"></i>
                </a>
            </div>
        </div>

        <div v-if="items" class="company-detail-carousel__content"
             :style="{'width': 'calc(' + 100 * items.length / count + '% + '+ 20 * items.length / count + 'px)', 'marginLeft': 'calc(-' + 100 * active / count + '% - ' + 20 * active / count + 'px)'}">
            <div class="company-detail-carousel__content__item" v-for="(item, index) in items" :key="index"
                 :style="{'width': 100 / items.length + '%'}">
                <company-course-card v-if="typeProp === 'course'" :key="index" :course="item"></company-course-card>
                <company-summer-camp-card v-if="typeProp === 'camp'" :key="index" :button-class="buttonClass" :company="companyProp" :camp="item"></company-summer-camp-card>
                <company-event-card v-if="typeProp === 'event'" :key="index" :event="item"></company-event-card>
            </div>
        </div>
    </div>
</template>

<script>
    import CompanyCourseCard from './CompanyCourseCard';
    import CompanySummerCampCard from './CompanySummerCampCard';
    import CompanyEventCard from './CompanyEventCard';

    export default {
        name: 'companydetailcarousel',
        components: {
            CompanyCourseCard,
            CompanyEventCard,
            CompanySummerCampCard,
        },
        props: {
            items: {
                type: Array,
                required: true,
                default: []
            },
            countProp: {
                type: Number,
                default: 4
            },
            typeProp: {
                type: String,
                default: 'course'
            },
            companyProp: {
                type: Object,
                default() {
                    return {}
                }
            },
            buttonClass: {
                type: String,
                default: 'btn-primary'
            },
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                active: 0,
                count: this.countProp
            }
        },
        mounted() {
            let self = this;
            this.resizeCount();

            window.addEventListener('resize', function () {
                self.resizeCount();
            });
        },
        methods: {
            resizeCount() {
                if (window.innerWidth <= 992)
                    this.count = 3;
                if (window.innerWidth <= 768)
                    this.count = 2;
            },
            prev() {
                if (this.items.length <= this.count) return;
                if (this.active === 0) {
                    this.active = this.items.length - this.count;
                } else {
                    this.active--;
                }
            },
            next() {
                if (this.items.length <= this.count) return;
                if (this.active === this.items.length - this.count) {
                    this.active = 0;
                } else {
                    this.active++;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyDetailCarousel.vue